import styled from 'styled-components'

export interface BaseAnimationProps {
  delay?: string
  duration?: string
}

const BaseAnimation = styled.div<BaseAnimationProps>`
  display: block;
  animation-duration: ${({ duration }) => duration ?? '1s'};
  animation-timing-function: ease;
  animation-delay: ${({ delay }) => delay ?? '0s'};
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: both;
  animation-play-state: running;
`

export default BaseAnimation
